import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as Badge } from '../../../assets/svg/icons/badge.svg';

export const BadgeIcon = (props: SvgIconProps) => {
    return <SvgIcon component={Badge} viewBox="0 0 24 32" {...props} />;
};
